import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CertificationsCards from "./CertificationsCards";
import Particle from "../Particle";



import nptel from "../../Assets/Certificates/nptel.png";
import postman from "../../Assets/Certificates/postman.jpg";
import mern from "../../Assets/Certificates/mern.jpg";
import sql from "../../Assets/Certificates/sql.jpg";
import devtown from "../../Assets/Certificates/devtown.jpg";
import js from "../../Assets/Certificates/js.jpg";



function Certifications() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Certifications </strong>
        </h1>
        <p style={{ color: "white" }}>
          A comprehensive showcase of my professional certifications earned throughout my journey.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="certifications-card">
            <CertificationsCards
              imgPath={nptel}
              isBlog={false}
              title="NPTEL - Programming In Java"
              description="Elite-certified Programming in Java course (92%) by NPTEL – IIT Kharagpur, focused on core Java and object-oriented programming."
            
              demoLink="https://drive.google.com/file/d/1YDkJIVeR7Q16FqYjdEWxEqh7q-9XPpxc/view?usp=drivesdk"
            />
          </Col>
        
        
          <Col md={4} className="certifications-card">
            <CertificationsCards
              imgPath={postman}
              isBlog={false}
              title="Postman API Student Expert"
              description="Postman API Fundamentals (Student Expert)
Certified by Postman with practical expertise in REST APIs, API testing, authorization, and automation workflows."
            
              demoLink="https://drive.google.com/file/d/1MuHgLk6rT6ZbV-f4BtmgTJKC1INg57SH/view?usp=drivesdk"
            />
          </Col>
      

        
          <Col md={4} className="certifications-card">
            <CertificationsCards
              imgPath={mern}
              isBlog={false}
              title="Devtown - MERN Stack Bootcamp"
              description="Completed a MERN Stack Bootcamp by DevTown in collaboration with GDG VIT-AP University, focused on full-stack web development and a real-world project."
            
              demoLink="https://drive.google.com/file/d/1D3tU1BhsBl5s1h3Vqw_oh4kA0xu_cXDX/view?usp=drivesdk"
            />
          </Col>
        

        
          <Col md={4} className="certifications-card">
            <CertificationsCards
              imgPath={sql}
              isBlog={false}
              title="Spoken Tutorial IIT Bombay- SQL Training"
              description="RDBMS PostgreSQL Training | IIT Bombay (Spoken Tutorial)
Hands-on training in PostgreSQL covering RDBMS concepts, SQL queries, database design, and optimization.
Score: 75%"
            
              demoLink="https://drive.google.com/file/d/1ahIWrSwxUen9Yj9ty9rYyvQhzYLcgKiO/view?usp=drivesdk"
            />
          </Col>

          
          <Col md={4} className="certifications-card">
            <CertificationsCards
              imgPath={devtown}
              isBlog={false}
              title="Devtown - Appreciation Certificate"
              description="Received a Certificate of Appreciation from DevTown for contributing to and supporting a national-level tech learning community initiative."

              demoLink="https://drive.google.com/file/d/1pQRvR0bbPt17CLhvWqvZJWcTfCht041m/view?usp=drivesdk"
            />
          </Col>

          
          <Col md={4} className="certifications-card">
            <CertificationsCards
              imgPath={js}
              isBlog={false}
              title="Let's Upgrade - Javascript Bootcamp"
              description="Completed a JavaScript Bootcamp by LetsUpgrade, focused on core JavaScript fundamentals and web development basics."
      
              demoLink="https://drive.google.com/file/d/1-6E5yHrk8mHEzvYzetLtp8Wd3kEaMwoL/view?usp=drivesdk"
            />
          </Col>

          </Row>
        

      </Container>
    </Container>
  );
}

export default Certifications;